import TimeFrameSelect from './TimeFrameSelect';

export default TimeFrameSelect;
